import type {
  ICampaign,
  ILinks,
  Milestone,
  SocialPostType,
} from "../../../../types/models/campaign.models.types";
import type {
  Platforms,
  SocialCreatorType,
  SocialGender,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import type { MilestoneRewardType } from "../../../../z/brand/campaign-form.brand.z";
import { usePostHttp } from "../../http.hook";

interface IBody {
  socialPlatform: SocialPlatforms;
  coverImage: string | null;
  favouriteSocial: string | null;
  brand: string;
  name: string;
  socialPostType: SocialPostType;
  socialCreatorType: SocialCreatorType | null;
  genderPreference: SocialGender | null;
  minimumFollowers?: number | null;
  maximumFollowers?: number | null;
  genre: Array<string> | null;
  milestoneRewardType?: MilestoneRewardType | null;
  locationPreference: Array<string> | null;
  startDate: Date | null;
  endDate: Date | null;
  budget: number | null;
  budgetInternal: number | null;
  hasFixedPayout: string | null;
  milestones: Array<Milestone>;
  highestMilestoneOnlyForTopPost: string;
  links: Array<ILinks> | null;
  productRefund: {
    image: string | null;
    link: string | null;
    couponCode: string | null;
    refundAmount: number | null;
  } | null;
  assets: Array<string>;
  sampleVideos: Array<string>;
  briefVideos: Array<string> | null;
  hashtags: string | null;
  mentions: string | null;
  aboutCampaign: string | null;
  do: string | null;
  dont: string | null;
  aboutPayment: string | null;
  aboutBrand: string | null;
  platform: Platforms;
}

interface IResponse {
  campaign: ICampaign;
}

export function useCreateCampaignAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns",
  });
}
